type CreateOverlapDataForFlightRequest = {
    boxes: number[][][]
    // abortSignal: AbortSignal
}
export const createOverlapDataForFlight = async (req: CreateOverlapDataForFlightRequest) => {
    const worker = new Worker(new URL("./createOverlapDataForFlight.worker.ts", import.meta.url))
    const output = await new Promise<{
        imageData: Uint8ClampedArray
        width: number
        height: number
        bbox: [number, number, number, number]
    }>((resolve, reject) => {
        worker.addEventListener("message", (message) => {
            if (message.data) {
                resolve(message.data)
            } else {
                reject()
            }
            worker.terminate()
        })

        // const abortWorker = () => {
        //     worker.terminate()
        //     reject("worker_aborted")
        // }

        // if (req.abortSignal.aborted) abortWorker()
        // else req.abortSignal.addEventListener("abort", abortWorker)

        worker.postMessage({ ...req, abortSignal: undefined })
    })
    return output
}
